import * as React from 'react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import PaymentScheduleImagePc from './images/payment-schedule-image-pc.png';
import './startDateSummary.module.scss';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';

type Props = {
  date: moment.Moment | null;
  onSubmit: (() => Promise<void>) | undefined;
};
const SelectedDateBox = ({ date, onSubmit }: Props) => {
  return (
    <div styleName="selected-date-box">
      <div styleName="title">以下の日程から受講を開始します</div>
      <div styleName="body">
        <div styleName="selected-date">{date ? `${date.format('YYYY年M月D日(dd)')}` : '日程未選択'}</div>
        <span styleName="note">
          {date ? '日程を変更する場合はカレンダーで選択してください' : '日程をカレンダーで選択してください'}
        </span>
      </div>
      <div styleName="button-wrapper">
        <Button id="default-box-submit" type="primary" size="l" onClick={onSubmit} disabled={!date}>
          日程を確定してプラン選択へ
        </Button>
      </div>
    </div>
  );
};

export const StartDateSummary = ({ date, onSubmit }: Props) => {
  const { isSp } = useViewportState();
  return (
    <div styleName="start-date-summary">
      <SelectedDateBox date={date} onSubmit={date ? onSubmit : undefined} />
      {!isSp && <img src={PaymentScheduleImagePc} alt="" />}
    </div>
  );
};
